import { FunctionComponent, ReactElement } from 'react';
import { IconButton, IconButtonProps, Stack } from '@mui/material';
import { RemoveCircleOutlineRounded } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import TextField, { TextFieldProps } from '../form-inputs/TextField';

type RemovableTextFieldProps = {
	onRemove?: () => void;
} & TextFieldProps;

const RemoveIconButton = styled(IconButton)<IconButtonProps>(() => ({
	padding: '0.25rem',
}));

const RemovableTextField: FunctionComponent<RemovableTextFieldProps> = ({
	onRemove,
	...rest
}): ReactElement => (
	<Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
		<TextField {...rest} />
		<RemoveIconButton size="small" onClick={onRemove}>
			<RemoveCircleOutlineRounded fontSize="small" />
		</RemoveIconButton>
	</Stack>
);

export default RemovableTextField;
